import React, {useEffect} from "react";
import {observer} from "mobx-react";
import styled from "styled-components";
import {Button, Col, DatePicker, Form, Input, Layout, message, Modal, Pagination, Row, Space, Table, Tooltip} from "antd";
import {Content, Header} from "antd/es/layout/layout";
import UploadFile from "../common/upload-file";
import {useStore} from "../../store";
import {ColumnsType} from "antd/lib/table";
import {SpecimenEntity} from "../../entity/specimen-entity";
import {deleteSpecimenInfoApi, getSpecimenListApi} from "../../http/manager";
import {transaction} from "mobx";
import Specimen from "./specimen";
import SpecimenDetail from "./specimen-detail";
import "../../css/table-scroll-y.css"


const SpecimenList: React.FC = () => {

    const {specimenStore} = useStore();

    useEffect(() => {
        querySpecimenList();
        return specimenStore.clear
    }, []);

    const columns: ColumnsType<SpecimenEntity> = [
        {
            title: '序号',
            width: 70,
            dataIndex: 'id',
            key: 'id',
            align: "center",
            render: (value, record, index) => {
                return <div>{index + 1}</div>
            }
        },
        {
            title: '馆藏条码',
            width: 100,
            dataIndex: 'libraryCode',
            key: 'libraryCode',
            align: "center",
            className: "tabeTitle",
            render: (value, record, index) => {
                return <div>{`${record.libraryCode}${record.barCode}`}</div>
            }
        },
        {
            title: '种中文名',
            width: 200,
            dataIndex: 'specimenName',
            key: 'specimenName',
            align: "center",
        },
        {
            title: '种拉丁名',
            width: 300,
            dataIndex: 'specimenCanonicalName',
            key: 'specimenCanonicalName',
            align: "center",
            ellipsis: {
                showTitle: false,
            },
            render: (text) => (
                <Tooltip placement="topLeft" title={text}>
                    {text}
                </Tooltip>
            ),
        },
        {
            title: '采集人',
            width: 150,
            dataIndex: 'gatherer',
            key: 'gatherer',
            align: "center",
        },
        // {
        //     title: '采集号',
        //     width: 150,
        //     dataIndex: 'gatherNumber',
        //     key: 'gatherNumber',
        //     align: "center",
        // },
        {
            title: '采集日期',
            width: 150,
            dataIndex: 'gatherDate',
            key: 'gatherDate',
            align: "center",
        },
        {
            title: '省市',
            width: 150,
            dataIndex: 'province',
            key: 'province',
            align: "center",
        },
        {
            title: '区县',
            width: 150,
            dataIndex: 'district',
            key: 'district',
            align: "center",
        },
        {
            title: '操作',
            width: 300,
            dataIndex: 'action',
            key: 'action',
            fixed: 'right',
            align: "center",
            render: (value, record) => {
                return <Space size="middle">
                    <Button onClick={() => toEditModal(record)} type={"primary"}>编辑</Button>
                    <Button onClick={() => toDetailModal(record)} type={"primary"}>详情</Button>
                    <Button onClick={() => openDeleteConfirm(record)} type={"primary"} danger={true}>删除</Button>
                </Space>
            }
        },
    ];

    const openDeleteConfirm = (record: SpecimenEntity) => {
        specimenStore.showDeleteConfirm(true);
        specimenStore.setDeleteRecord(record);
    }

    const deleteButton = () => {
        const params = {
            id: specimenStore.deleteRecord.id,
        }
        deleteBaseLibrary(params);
    }

    const deleteBaseLibrary = (params: any) => {
        deleteSpecimenInfoApi(params)
            .then((res) => {
                if (Number(res.code) === 200) {
                    message.success("删除成功");
                    onDeleteConfirmClose();
                    querySpecimenList(false);
                } else {
                    if (res.message) {
                        message.error(res.message);
                    } else {
                        message.error("删除失败");
                    }
                }
            }).catch(() => {
            message.error("删除失败");
        })
    }

    const toEditModal = (record: SpecimenEntity) => {
        specimenStore.setDetailType("edit");
        specimenStore.setBaseLibraryDetail(record);
        specimenStore.setShowEdit(true)
    }

    const toDetailModal = (record: SpecimenEntity) => {
        specimenStore.setBaseLibraryDetail(record);
        specimenStore.setShowDetail(true)
    }

    const openUploadFileModal = () => {
        specimenStore.setShowUpload(true);
    }

    const setNameCn = (e: any) => {
        specimenStore.condition.specimenName = e.target.value;
    }

    const setLatin = (e: any) => {
        specimenStore.condition.specimenCanonicalName = e.target.value;
    }

    const setGatherer = (e: any) => {
        specimenStore.condition.gatherer = e.target.value;
    }

    const setGatherDate = (date: any, dateString: string) => {
        specimenStore.condition.gatherDate = dateString;
    }

    const setProvince = (e: any) => {
        specimenStore.condition.province = e.target.value;
    }
    const setDistrict = (e: any) => {
        specimenStore.condition.district = e.target.value;
    }
    const setAuthenticate = (e: any) => {
        specimenStore.condition.authenticateEr = e.target.value;
    }
    const onQuery = () => {
        querySpecimenList();
    }
    const onResetOnclick = () => {
        specimenStore.resetQueryCondition();
        querySpecimenList();
    }
    const OnDetailModalClose = () => {
        specimenStore.setShowDetail(false);
    }

    const OnEditModalClose = () => {
        specimenStore.setShowEdit(false);
    }

    const onEditSuccess = () => {
        specimenStore.setShowEdit(false);
        querySpecimenList(false);
    }

    const openAddSpecimenModal = () => {
        specimenStore.clearDetail()
        specimenStore.setDetailType("add");
        specimenStore.setShowEdit(true);
    }

    const querySpecimenList = (isClear: boolean = true) => {
        const params = {
            specimenName: specimenStore.condition.specimenName,
            specimenCanonicalName: specimenStore.condition.specimenCanonicalName,
            gatherer: specimenStore.condition.gatherer,
            gatherDate: specimenStore.condition.gatherDate,
            province: specimenStore.condition.province,
            district: specimenStore.condition.district,
            authenticateEr: specimenStore.condition.authenticateEr,
            pageNum: specimenStore.pagination.pageNum,
            pageSize: specimenStore.pagination.pageSize,
        }
        getSpecimenListApi(params)
            .then((res) => {
                refreshTableData((res.data && res.data.list && res.data.list.length > 0) ? res.data.list : []);
                specimenStore.pagination.total = res.data ? res.data.total : 0
            })
    }

    const refreshTableData = (data: SpecimenEntity[]) => {
        const list: SpecimenEntity[] = [];
        data.forEach((item) => {
            item.key = String(item.id);
            list.push(item);
        })
        transaction(() => {
            specimenStore.setDataSource(list);
        })
    }

    const onUploadClose = () => {
        specimenStore.setShowUpload(false);
    }

    const onUploadSuccess = () => {
        onUploadClose();
        onQuery();
    }

    const onDeleteConfirmClose = () => {
        specimenStore.showDeleteConfirm(false);
    }

    const onSizeChange = (page: any, pageSize: any) => {
        specimenStore.pagination.pageSize = pageSize;
        specimenStore.pagination.pageNum = page;
        onQuery();
    }

    return (
        <Layout style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Header style={{background: "#ffffff", borderBottom: "1px solid #d3d3d3", padding: "0 0 0 0"}}>
                <TitleSpan>植物标本</TitleSpan>
            </Header>
            <Content style={{ flex: 1, overflow: 'hidden' }}>
                <Wrapper>
                    <SearchWrapper>
                        <Space>
                            <Button onClick={openUploadFileModal} type={"primary"}
                                    style={{width: "100px", margin: "15px 0 15px 15px"}} size={"large"}>批量上传</Button>
                            <Button onClick={openAddSpecimenModal} type={"default"}
                                    style={{width: "100px", margin: "15px 0 15px 15px"}} size={"large"}>新建</Button>
                        </Space>
                        <Form labelAlign={"right"} wrapperCol={{span: "15"}}>
                            <Row justify={"space-between"} gutter={[15, 0]}>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"种中文名"}><Input onChange={setNameCn}
                                                                     value={specimenStore.condition.specimenName}
                                                                     placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"种拉丁名"}><Input onChange={setLatin}
                                                                     value={specimenStore.condition.specimenCanonicalName}
                                                                     placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"采集人"}><Input onChange={setGatherer}
                                                                    value={specimenStore.condition.gatherer}
                                                                    placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"采集日期"}><DatePicker size={"middle"} onChange={setGatherDate}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"省市"}><Input onChange={setProvince}
                                                                   value={specimenStore.condition.province}
                                                                   placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"区县"}><Input onChange={setDistrict}
                                                                   value={specimenStore.condition.district}
                                                                   placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Form.Item labelCol={{span:"7"}} label={"鉴定人"}><Input onChange={setAuthenticate}
                                                                    value={specimenStore.condition.authenticateEr}
                                                                    placeholder={"请输入"}/></Form.Item>
                                </Col>
                                <Col span={6}>
                                    <Space size={["middle", "large"]}>
                                        <Button onClick={onQuery} type={"primary"}>查询</Button>
                                        <Button onClick={onResetOnclick} type={"default"}>重置</Button>
                                        {/*<Button onClick={onResetOnclick} type={"primary"} danger={true}>批量删除</Button>*/}
                                    </Space>
                                </Col>
                            </Row>
                        </Form>
                    </SearchWrapper>
                    <ContentWrapper>
                        <Table
                            rowClassName={(type, index, intent) => {
                                return index % 2 === 0 ? "tableItemWhite" : "tableItemGray";
                            }}
                            style={{margin: "15px 15px 0 15px"}}
                            size={"small"}
                            bordered={true}
                            // rowSelection={{fixed:"left", type:"checkbox"}}
                            dataSource={specimenStore.dataSource}
                            columns={columns}
                            pagination={{position: [], pageSize: specimenStore.pagination.pageSize}}
                        />
                        <Pagination
                            size={"small"}
                            style={{margin: "15px 15px 15px 0", alignSelf: "end"}}
                            total={specimenStore.pagination.total}
                            showQuickJumper={true}
                            showSizeChanger={true}
                            defaultPageSize={10}
                            hideOnSinglePage={true}
                            onChange={onSizeChange}
                            current={specimenStore.pagination.pageNum}
                        />
                    </ContentWrapper>
                </Wrapper>
                <Modal onCancel={OnDetailModalClose}
                       width={"750px"}
                       open={specimenStore.isShowDetail}
                       closable={true}
                       centered={true}
                       footer={null}
                       mask={true}
                       title={"标本详情"}
                       destroyOnClose={true}
                       maskClosable={true}>
                    <SpecimenDetail/>
                </Modal>
                <Modal onCancel={OnEditModalClose}
                       width={"750px"}
                       open={specimenStore.isShowEdit}
                       closable={true}
                       centered={true}
                       footer={null}
                       mask={true}
                       destroyOnClose={true}
                       title={specimenStore.detailType === "add" ? "新建标本" : "编辑标本"}
                       maskClosable={true}>
                    <Specimen onSuccess={onEditSuccess}/>
                </Modal>
                <Modal onCancel={onUploadClose}
                       width={"500px"}
                       open={specimenStore.isShowUpload}
                       closable={true}
                       centered={true}
                       footer={null}
                       destroyOnClose={true}
                       mask={true}
                       title={"批量上传"}
                       maskClosable={true}>
                    <UploadFile onSuccess={onUploadSuccess} funType={2}/>
                </Modal>
                <Modal onCancel={onDeleteConfirmClose}
                       onOk={deleteButton}
                       width={"300px"}
                       okType={"primary"}
                       okText={"确认"}
                       open={specimenStore.isShowDeleteCOnfirm}
                       closable={true}
                       title={"提示"}
                       centered={true}
                       destroyOnClose={true}
                       mask={true}
                       maskClosable={true}>
                    <div>确认删除该数据</div>
                </Modal>
            </Content>
        </Layout>
    );
}
export default observer(SpecimenList);

const TitleSpan = styled.span`
  & {
    font-size: 20px;
    line-height: 16px;
    text-align: center;
    color: #333333;
    font-weight: 450;
    margin-left: 15px;
  }
`;
const Wrapper = styled.div`
  & {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: auto;

    .tableItemWhite {
      background: white;
    }

    .tableItemGray {
      background: #F9FAFD;
    }

    .ant-table-body {
      overflow-x: scroll !important;
    }
  }
`;
const SearchWrapper = styled.div`
  & {
    margin: 15px 15px 0 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;
    .ant-picker{
      width: 100%;
    }
  }
`;
const ContentWrapper = styled.div`
  & {
    margin: 15px;
    border-radius: 4px;
    border: 1px solid #EAEDF7;
    background: white;
    display: flex;
    flex-direction: column;
  }
`;

